import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.EditParticipantsPopup', {
    doneButtonText: 'Done',
    descriptionText: `
        Add or remove Approvers in the step "{stepName}".{br}Please provide a comment
        to let {authorName} as well as the Approvers know why you decided to do this.`,
    popupTitle: 'Change Approvers',
    doneButtonTitle: 'Change Approvers',
    addApproverButtonText: 'Add an Approver',
});
